export const getABTestLocation = () => {
  const location = window.location.pathname;
  const isCreateMode = location.startsWith("/explorations/ab-test/create");
  const isEditMode = !isCreateMode && location.startsWith("/explorations/ab-test");
  const isShareMode = location.startsWith("/explorations/ab-test/share");
  return { isCreateMode, isEditMode, isShareMode };
};
